import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { faChevronRight, faClipboardList, faEnvelope, faPhoneAlt, faSignOutAlt, faUser, faUserEdit, faUserFriends } from '@fortawesome/free-solid-svg-icons';
import { SocialAuthService } from 'angularx-social-login';
import { MyapiService } from '../services/myapi.service';
export interface userinfo {
  Email: string,
  FullName: string,
  HasRegistered: boolean,
  PhoneNumber: string,
  UserID: string,
}

@Component({
  selector: 'app-users',
  templateUrl: './users.component.html',
  styleUrls: ['./users.component.css']
})
export class UsersComponent  {
  
}
